export interface EditorDeepLink {
    projectId: number;
    workProductId: number;
    featureId?: number;
    storyId?: string;
    level: "PRODUCT" | "FEATURE" | "USERSTORY";
}

const EDITOR_PATH = /^\/dashboard\/products\/(\d+)\/editor\/(\d+)\/?$/;

export function parseEditorDeepLink(pathname: string, search = ""): EditorDeepLink | null {
    const match = EDITOR_PATH.exec(pathname);
    if (!match) return null;

    const projectId = Number(match[1]);
    const workProductId = Number(match[2]);
    if (!Number.isSafeInteger(projectId) || projectId <= 0 || !Number.isSafeInteger(workProductId) || workProductId <= 0) {
        return null;
    }

    const params = new URLSearchParams(search);
    const featureValue = params.get("feature");
    const storyValue = params.get("story")?.trim() || undefined;
    const featureId = featureValue ? Number(featureValue) : undefined;
    if (featureValue && (!Number.isSafeInteger(featureId) || featureId! <= 0)) return null;
    if (storyValue && featureId === undefined) return null;

    return {
        projectId,
        workProductId,
        ...(featureId !== undefined ? { featureId } : {}),
        ...(storyValue ? { storyId: storyValue } : {}),
        level: storyValue ? "USERSTORY" : featureId !== undefined ? "FEATURE" : "PRODUCT"
    };
}

export function editorDeepLinkUrl(link: Omit<EditorDeepLink, "level">): string {
    const params = new URLSearchParams();
    if (link.featureId !== undefined) params.set("feature", String(link.featureId));
    if (link.storyId) params.set("story", link.storyId);
    const query = params.toString();
    const path = `/dashboard/products/${link.projectId}/editor/${link.workProductId}`;
    return query ? `${path}?${query}` : path;
}
